import { Popup } from '@shared/layouts/popup/popup'
import { useTranslation } from 'react-i18next'

import { Text } from '@components/text'
import { Title } from '@components/title/title'

import { Button } from '../../shared/ui/button/button'
import BackgroundImg from './assets/img/background-404.png'
import DigitsImg from './assets/img/logo-404.png'

import styles from './not-found-page.module.css'
import { useNavigate } from '@tanstack/react-router'

export const NotFoundPage = (): JSX.Element => {
  const { t } = useTranslation('main')
  const navigate = useNavigate()
  const handleBtnClick = (): void => {
    navigate({
      to: '/'
    })
  }
  return (
    <Popup isOpened={true} onClose={handleBtnClick} withClose>
      <div className={styles.container}>
        <img src={BackgroundImg} className={styles.background} />
        <img src={DigitsImg} className={styles.logo} />
        <Title size="lg" className={styles.title}>
          {t('not-found-title')}
        </Title>
        <Text size="xl" appearance="inactive" className={styles.text}>
          {t('not-found-text')}
        </Text>
        <Button className={styles.btn} sizeType="lg" onClick={handleBtnClick}>
          {t('back-to-main')}
        </Button>
      </div>
    </Popup>
  )
}
